import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { getField } from "../../lib/api";
import { useLoaderData } from "react-router";
import { IAPIResponse, IField } from "../../types/api";
import { Link } from "react-router-dom";

export const loader = async ({ params }: any) => {
    return {
        field: await getField(params.id),
    };
};

const Field = (): React.JSX.Element => {
    const {
        field: { field },
    } = useLoaderData() as { field: IAPIResponse & { field: IField } };

    const mapAddress = encodeURIComponent(
        `${field.address} ${field.city}, ${field.state}`,
    );

    return (
        <div data-testid="fieldContent">
            <Container className="py-5 field">
                <Row>
                    {field.address && (
                        <Col xs={12} md={10}>
                            <h3>{field.address}</h3>
                            <h3>
                                {field.city}, {field.state} {field.zip}
                            </h3>

                            <iframe
                                data-testid="map"
                                width="100%"
                                height="500"
                                style={{ border: 0 }}
                                referrerPolicy="no-referrer-when-downgrade"
                                src={`https://www.google.com/maps/embed/v1/place/?key=${process.env.GOOGLE_MAPS_API_KEY}&q=${mapAddress}`}
                            ></iframe>
                            <Link
                                className="btn btn-primary"
                                to={`https://www.google.com/maps/dir//${mapAddress}`}
                                target="_blank"
                            >
                                Get Directions
                            </Link>
                        </Col>
                    )}
                </Row>
            </Container>
        </div>
    );
};

export default Field;
